module Omni.Booker {
    NgModule.component("signInModal", {
        templateUrl: "sign-in-modal",
        bindings: {
            message: "@",
            close: "&",
            dismiss: "&"
        },
        controller: class SignInModalController {
            private close;  // Referential
            private dismiss; // Referential
            static $inject =[];
            constructor() {

            }

            public $onInit() {
                //TODO: Grab data from service, parse whatever needs to be parsed here and bind data to controller (and hidden fields)
                //var startDate = new Date(Date.parse($j("form#find-and-book-form #hdnStartDate").val()));
                //var startDateString = (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/" + startDate.getFullYear();
                //var endDate = new Date(Date.parse($j("form#find-and-book-form #hdnEndDate").val()));
                //var endDateString = (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear();
                
            }

            //public submit = ($event) => {
            //    angular.element("[name='navFormSI']").submit();
            //    //$http.post('http://posttestserver.com/post.php?dir=jsfiddle', JSON.stringify(data)).success(function () {/*success callback*/ });
            //}

            public ok = () => {
                this.close({ $value: 'confirm' });
            }

            public cancel = () => {
                this.dismiss({ $value: 'cancel' });
            }
        }
    });
}